import { EnvConfig } from "..";

const config: EnvConfig = {
  basketBFFBaseUrl: "https://api.integration.project4.com/basket-ui",
  socialProofApi:
    "https://api.integration.project4.com/product-badging/api/v1/social-proof-messaging",
};

export default config;
